import useFetchAndTrace from "../fetchWithTrace";
import { useCallback } from "react";
import { Response } from "next/dist/compiled/@edge-runtime/primitives";

export class SWRFetchError<T = void> extends Error {
  status: number;
  info?: T;

  constructor(status: number) {
    super();
    this.status = status;
  }
}

interface SWRFetcherOptions {
  noAuth?: boolean;
}

export default function useSWRFetcher<Data = void>(
  transformer?: (response: Response) => Promise<Data>,
  options?: SWRFetcherOptions,
) {
  const fetchAndTrace = useFetchAndTrace(true);

  return useCallback(
    async (url: string) => {
      const response = (await fetchAndTrace(
        url,
        null,
        null,
        undefined,
        options?.noAuth,
      )) as Response;
      if (response.ok) {
        if (transformer === undefined) {
          return (await response.json()) as Data;
        } else {
          return await transformer(response);
        }
      } else {
        throw new SWRFetchError(response.status);
      }
    },
    [fetchAndTrace, options?.noAuth, transformer],
  );
}
